// import { RulesListResponse } from '../client/ria-multi-agent-system.schemas'

import {
  AssigneeRole,
  ExecutableRulesListResponse,
} from '../client/ria-multi-agent-system.schemas'

export const executablePolicyRulesMock: ExecutableRulesListResponse = {
  total: 2,

  rules: [
    {
      rule_id: 'EMPLOYEE-105E088F',
      category: 'Employee Lifecycle',
      title:
        'Disable account when HR status indicates user has left (status = terminated/left)',
      description:
        'When HR/status indicates a user has left or been terminated, their Entra account must be disabled immediately and groups removed. All conditions are required to avoid no-op actions (account must be currently enabled and user must have groups to remove).',
      assignee_role: AssigneeRole.HRCoordinator,
      assignee_email: 'afsdf',
      conditions: [
        {
          source: 'sap_sf',
          field: 'status',
          operator: 'in_list',
          value: ['terminated', 'left'],
        },
        {
          source: 'entra',
          field: 'account_enabled',
          operator: 'equals',
          value: true,
        },
        {
          source: 'entra',
          field: 'groups',
          operator: 'is_not_null',
          value: null,
        },
      ],
      severity: 'critical',
      tasks: [
        {
          agent: 'topdesk_agent',
          task_type: 'entra_disable_account',
          description_template:
            'Disable Entra account for user {user_id} because HR status indicates termination/left (sap_sf.status). Ensure account is currently enabled before disabling.',
          approval_required: true,
          priority: 1,
        },
        {
          agent: 'topdesk_agent',
          task_type: 'entra_remove_groups',
          description_template:
            'Request removal of all groups for user {user_id} after disabling account due to termination/left. Verify user has groups before removal.',
          approval_required: true,
          priority: 2,
        },
      ],
      source_policy: 'IT009 - Logical Access Control policy SOM V4.0.pdf',
    },
    {
      rule_id: 'EMPLOYEE-9FA28B10',
      category: 'Employee Lifecycle',
      title: 'Disable account when contract end date is reached or passed',
      description:
        "When a user's contract end date is on or before today, disable their Entra account and remove groups. Conditions ensure the account is enabled and that group removal is necessary.",
      assignee_role: AssigneeRole.ITSecurityManager,
      conditions: [
        {
          source: 'sap_sf',
          field: 'contract_end_date',
          operator: 'less_than_or_equal',
          value: '{today}',
        },
        {
          source: 'entra',
          field: 'account_enabled',
          operator: 'equals',
          value: true,
        },
        {
          source: 'entra',
          field: 'groups',
          operator: 'is_not_null',
          value: null,
        },
      ],
      severity: 'critical',
      tasks: [
        {
          agent: 'topdesk_agent',
          task_type: 'entra_disable_account',
          description_template:
            'Disable Entra account for user {user_id} because contract_end_date <= {today}. Ensure account is currently enabled before disabling.',
          approval_required: true,
          priority: 1,
        },
        {
          agent: 'topdesk_agent',
          task_type: 'entra_remove_groups',
          description_template:
            'Request removal of all groups for user {user_id} after disabling account due to contract end. Verify user has groups before removal.',
          approval_required: true,
          priority: 2,
        },
      ],
      source_policy: 'IT009 - Logical Access Control policy SOM V4.0.pdf',
    },
  ],
}
